module.exports = __webpack_public_path__ + "img/login_logo.01cfe9bc.png";